//ResDetailsHistory
export const HISTORY_REQUEST = "HISTORY_REQUEST";
export const HISTORY_SUCCESS = "HISTORY_SUCCESS";
export const HISTORY_FAIL = "HISTORY_FAIL";

//LoadResDetails
export const RESDETAILS_REQUEST = "RESDETAILS_REQUEST";
export const RESDETAILS_SUCCESS = "RESDETAILS_SUCCESS";
export const RESDETAILS_FAIL = "RESDETAILS_FAIL";

//insert reservation
export const POSTBOOKING_REQUEST = "POSTBOOKING_REQUEST";
export const POSTBOOKING_SUCCESS = "POSTBOOKING_SUCCESS";
export const POSTBOOKING_FAIL = "POSTBOOKING_FAIL";


export const PRIORITY_LIST_REQUEST = "PRIORITY_LIST_REQUEST";
export const PRIORITY_LIST_SUCCESS = "PRIORITY_LIST_SUCCESS";
export const PRIORITY_LIST_FAIL = "PRIORITY_LIST_FAIL";


export const LOG_RESERVATION_REQUEST = "LOG_RESERVATION_REQUEST";
export const LOG_RESERVATION_SUCCESS = "LOG_RESERVATION_SUCCESS";
export const LOG_RESERVATION_FAIL = "LOG_RESERVATION_FAIL";




export const CANCEL_RESERVATION_REQUEST = "CANCEL_RESERVATION_REQUEST";
export const CANCEL_RESERVATION_SUCCESS = "CANCEL_RESERVATION_SUCCESS";
export const CANCEL_RESERVATION_FAIL = "CANCEL_RESERVATION_FAIL";


